VLW.Newsletter = class extends VLW.classBase {
	constructor(elt) {
		super();
		this.form = elt;
		this.NEWSLET_validForm = this.validForm(
			this.form,
			"/l/1800-NewsletterInscription?form_name=NEWSLETTER&langue=" + document.querySelector("html").getAttribute("lang"),
			this.validForm_onSuccess(this.form),
			{category: "Inscription", action: "Newsletter"}
		);
		this.onSubmitFunc =  this.submitForm(this.form, this.NEWSLET_validForm);
		this.form.addEventListener("submit"	,this.onSubmitFunc );
	}
	instanceClean(){
		this.form.removeEventListener("submit"	, this.onSubmitFunc);
		super.instanceClean();
	}


	static serialize(obj, prefix) {
		var str = [], p;
		for (p in obj) {
			if (obj.hasOwnProperty(p)) {
				var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
				str.push((v !== null && typeof v === "object") ?VLW.Newsletter.serialize(v, k) :encodeURIComponent(k) + "=" + encodeURIComponent(v));
			}
		}
		return str.join("&");
	}

	static ajax(url, data, callBack) {
		let ajax = new XMLHttpRequest();
		ajax.open('POST', url, true);
		ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded; charset=UTF-8");
		ajax.onreadystatechange = callBack;
		ajax.send(VLW.Newsletter.serialize(data));
	}


	submitForm(form, validFunction) {
		return function (e) {
			TweenMax.set(form.querySelector(".submit"), {className: "+=__hide"});
			validFunction();
			e.preventDefault();
			return false;
		}
	}

	validForm(form, url, callBackSuccess, eventData) {
		return function () {
			if (VLW.Newsletter.checkInputError(form.querySelectorAll("input[type='text'][required], input[type='email'][required]")) === 0) {
				site.trackEvent(eventData.category, eventData.action);
				VLW.Newsletter.ajax(url,{
					NEWSLETTER_email:form.querySelector("[name='NEWSLETTER[email]']").value,
					NEWSLETTER_prenom:form.querySelector("[name='NEWSLETTER[prenom]']").value,
					NEWSLETTER_nom:form.querySelector("[name='NEWSLETTER[nom]']").value,
				},callBackSuccess);
			} else {
				TweenMax.set(form.querySelector(".submit"), {className: "-=__hide", delay: .75});
			}
		}
	}

	validForm_onSuccess(form) {
		return function (e) {
			if (e.currentTarget.readyState === 4 && e.currentTarget.status === 200) {
				form.querySelector(".cntrMessage").innerHTML = JSON.parse(e.currentTarget.response).message;
				TweenMax.set(form.querySelector(".cntrMessage"), {className: "+=__show", delay: 0});
				TweenMax.set(form.querySelector(".cntrMessage"), {className: "-=__show", delay: 2});
				TweenMax.set(form.querySelector(".submit"), {className: "-=__hide", delay: 2.5});
				(JSON.parse(e.currentTarget.response).success === true && form.reset());
			}
		};
	}

	static checkInputError(inputs){
		var nb_error = 0;
		for (var i = 0, j = inputs.length; i < j; i++) {
			switch (inputs[i].getAttribute("type")) {
				case "text":
					nb_error += (VLW.Newsletter.validText(inputs[i])) ? 0 :  1;
					break;
				case "email":
					nb_error += (VLW.Newsletter.validEmail(inputs[i])) ? 0 :  1;
					break;
			}
		}
		return nb_error;
	}
	static validEmail (input) {
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		re.test(input.value)?input.classList.remove('error'):input.classList.add('error');
		return !input.classList.contains('error');
	}
	static validText(input) {
		(input.value.trim() == "")?input.classList.add('error'):input.classList.remove('error');
		return !input.classList.contains('error');
	}

};